import { useStores } from "src/hooks";
import { mediaSortOptions } from "./media.constants";

export const openBackgroundRemovalErrorNotification = (message: string) => {
  const { notificationStore, localeStore } = useStores();

  notificationStore.open({
    title: localeStore.t(
      'media["media-control-panel"].filters["filters-dialog"]["modal-titles"].background',
    ),
    message: message,
    confirmText: localeStore.t("common.buttons.confirm"),
    cancelText: "",
    onlyConfirm: true,
  });
};

export const openRetouchErrorNotification = (message: string) => {
  const { notificationStore, localeStore } = useStores();

  notificationStore.open({
    title: localeStore.t(
      'media["media-control-panel"].filters["filters-dialog"]["modal-titles"].retouch',
    ),
    message: message,
    confirmText: localeStore.t("common.buttons.confirm"),
    cancelText: "",
    onlyConfirm: true,
  });
};

export const openDustRemovalErrorNotification = (message: string) => {
  const { notificationStore, localeStore } = useStores();

  notificationStore.open({
    title: localeStore.t(
      'media["media-control-panel"].filters["filters-dialog"]["modal-titles"].dust',
    ),
    message: message,
    confirmText: localeStore.t("common.buttons.confirm"),
    cancelText: "",
    onlyConfirm: true,
  });
};

export const openGenerativeAIErrorNotification = () => {
  const { notificationStore, localeStore } = useStores();

  notificationStore.open({
    title: localeStore.t('["edit-media"]["generative-ai"].failed_title'),
    message: localeStore.t('["edit-media"]["generative-ai"].failed_message'),
    confirmText: localeStore.t("common.buttons.confirm"),
    confirmAppearance: "tertiaryOutlined",
    cancelText: "",
    onlyConfirm: true,
  });
};

export const openGenerativeAINotAvailable = () => {
  const { notificationStore, localeStore } = useStores();

  notificationStore.open({
    title: localeStore.t('["edit-media"]["generative-ai"].not_available'),
    confirmText: localeStore.t("common.buttons.confirm"),
    confirmAppearance: "tertiaryOutlined",
    cancelText: "",
    onlyConfirm: true,
  });
};

export const openGenerativeAIHighStyleTips = (cb: any) => {
  const { notificationStore, localeStore } = useStores();

  notificationStore.open({
    title: localeStore.t('["edit-media"]["generative-ai"].change_higt_style_title'),
    message: localeStore.t('["edit-media"]["generative-ai"].change_higt_style_desc'),
    cancelText: localeStore.t('["edit-media"]["generative-ai"].change_higt_style_cancel'),
    confirmText: localeStore.t('["edit-media"]["generative-ai"].change_higt_style_confirm'),
    confirmAppearance: "primary",
    onOk: () => {
      cb && cb(true);
    },
    onCancel: () => {
      cb && cb(false);
    },
  });
};

export const getMediaSortOptionsLocalized = () => {
  const { localeStore } = useStores();

  return mediaSortOptions.map(({ value, label }) => {
    switch (value) {
      case "all":
        return {
          label: localeStore.t(
            'media["media-control-panel"].filters["filters-dialog"]["media-options"].all',
          ),
          value,
        };
      case "withoutSkuFirst":
        return {
          label: localeStore.t(
            'media["media-control-panel"].filters["filters-dialog"]["media-options"]["without-sku-first"]',
          ),
          value,
        };
      case "skuFirst":
        return {
          label: localeStore.t(
            'media["media-control-panel"].filters["filters-dialog"]["media-options"]["sku-first"]',
          ),
          value,
        };
      default:
        return { label, value };
    }
  });
};
